<template>
	<div>
		<span style="padding-left:20px;" v-if="isShow">
			注：上传文件大小限制为2M；格式支持Word、PPT、Excel、TXT、图片类型文件；最多支持上传3个附件
		</span>
		<Upload v-else :show-upload-list="false" :action="actionPath" :max-size="2048"
			:format="['doc','docx','xls','xlsx','ppt','txt','jpg','jepg','pdf','png']"
			:on-format-error="upLoadFormatError" :on-exceeded-size="uploadFileSizeError"
			:before-upload="upLoadBefore" :on-success="upLoadFileSuccess" :on-error="upLoadFileError">
			<Button type="dashed" title="添加单据">
				<Icon type="ios-create-outline" size='18'/>
				添加单据
			</Button>
			<span style="padding-left:20px;">
				注：上传文件大小限制为2M；格式支持Word、PPT、Excel、TXT、图片类型文件；最多支持上传3个附件
			</span>
		</Upload>
		<ul class="fileList">
			<li v-for="item in localList">
				<img src="/static/imgs/qitadanju.png" class="jxyd-imgicon" />
				<a :href="item.url" style="color:#666;"> {{item.name}}</a>
				<Icon type="md-trash" size='18' class="icon-item-dele" @click="deleFile(item.url)" v-show="!isShow"/>
			</li>
		</ul>
	</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		name: 'DocumentFile',
		props: ['actionPath','fileList','isShow'],
		data() {
			return {
				localList:this.fileList
			}
		},
		methods: {
			upLoadBefore(file) {
				if (this.localList.length >= 3) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '最多上传3个文件!'
					});
					return false;
				}
			},
			upLoadFileSuccess(response, file, fileList) {
				if (response.state == 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '上传失败：' + response.errorMsg + '!'
					});
					return;
				}
				
				this.localList.push({
					name: response.data[0].name,
					url: response.data[0].url,
					creator: parseInt(localStorage.getItem("userId"))
				});
			},
			upLoadFileError(error, file, fileList) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: '上传失败：' + error + '!'
				});
			},
			upLoadFormatError(file) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: '上传失败：请选择doc、docx、xls、xlsx、ppt、txt、jpg、jepg、pdf、png等格式文件！'
				});
			},
			uploadFileSizeError(file) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: '上传失败：不可选择超过2M大小文件！'
				});
			},
			deleFile(url) {
				for (var i = 0; i < this.localList.length; i++) {
					if (this.localList[i].url == url) {
						this.localList.splice(i, 1);
					}
				}
			}
		},
		watch:{
			localList: {
			    deep: true,
			    handler(arr) {
					// 触发一个自定义事件，通知父组件
					this.$emit('update:fileList', arr);
			    }
			},
			fileList:{
				deep: true,
				handler(arr) {
					this.localList = arr;
				}
			}
		},
		created: function() {},
	}
</script>

<style scoped>
	.fileList {
		margin-top: 15px;
	}
	
	.fileList li {
		margin-bottom: 7px;
	}
	
	.icon-item-dele {
		cursor: pointer;
		margin-left: 50px;
	}

	.icon-item-dele:hover {
		transform: scale(1.3);
	}

</style>